import { Helmet } from 'react-helmet';

interface HeadUpdaterProps {
  title?: string;
  faviconUrl?: string;
  description?: string;
}

export const HeadUpdater = ({ title, faviconUrl, description }: HeadUpdaterProps) => {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {faviconUrl && <link rel='icon' type='image/svg+xml' href={faviconUrl} />}
      {description && <meta name='description' content={description} />}
    </Helmet>
  );
};
